function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  y1: 0.5,
  x2: 1,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#da0000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9f0000"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-478.354 -2995.375)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M511.136,2995.747a10.885,10.885,0,0,1,7.342.611h0a10.9,10.9,0,0,0,9.042,0h0a10.9,10.9,0,0,1,13.395,3.589h0a10.9,10.9,0,0,0,7.831,4.521h0a10.9,10.9,0,0,1,9.806,9.806h0a10.9,10.9,0,0,0,4.52,7.83h0a10.9,10.9,0,0,1,3.59,13.4h0a10.9,10.9,0,0,0,0,9.042h0a10.9,10.9,0,0,1-3.59,13.4h0a10.9,10.9,0,0,0-4.52,7.831h0a10.9,10.9,0,0,1-9.806,9.8h0a10.9,10.9,0,0,0-7.831,4.521h0a10.9,10.9,0,0,1-13.395,3.589h0a10.909,10.909,0,0,0-9.042,0h0a10.9,10.9,0,0,1-13.4-3.589h0a10.9,10.9,0,0,0-7.83-4.521h0a10.9,10.9,0,0,1-9.806-9.8h0a10.9,10.9,0,0,0-4.521-7.831h0a10.9,10.9,0,0,1-3.589-13.4h0a10.9,10.9,0,0,0,0-9.042h0a10.9,10.9,0,0,1,3.589-13.4h0a10.9,10.9,0,0,0,4.521-7.83h0a10.9,10.9,0,0,1,9.806-9.806h0a10.9,10.9,0,0,0,7.83-4.521h0A10.884,10.884,0,0,1,511.136,2995.747Z",
  fill: "url(#a)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37.182,
  cy: 37.182,
  r: 37.182,
  transform: "translate(485.817 3002.838)",
  fill: "none",
  stroke: "#fbb03b",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 9.992,
  cy: 9.406,
  rx: 9.992,
  ry: 9.406,
  transform: "translate(512.83 3014.716)",
  fill: "#fbb03b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M526.177,3035.693l-.272.571-2.02,4.176,2.386,13.262-.016.018.016.086-3,3.282-3-3.021.013-.081-.013-.014,2.129-13.535-1.844-4.268-.249-.589c-14.474,3.117-14.479,29.136-14.479,29.136h34.352S540.171,3039.275,526.177,3035.693Zm4.864,13.828-1.858.862.446-2-1.394-1.5,2.039-.193,1-1.79.814,1.879,2.01.4-1.536,1.355.246,2.034Z",
  fill: "#fbb03b"
}));

var SvgSenior = function SvgSenior(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89.29,
    height: 89.29,
    viewBox: "0 0 89.29 89.29",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSenior, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/senior.da23359e.svg";
export { ForwardRef as ReactComponent };